/* MessageDialogComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./MessageDialogRenderer");
const _ = require('lodash');

class MessageDialogComponent extends EventEmitter{
    constructor() {
        super();
        this._optionsDefaults = {
            message: "I AM A MESSAGE",
            confirmButtonName: "OK"
        };
        this._options = null;
        this._renderer = new Renderer(this);
        this._showDialog = false;
        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        return prom;
    }
    showMessage(opts){
        this._options = _.defaults({}, opts, this._optionsDefaults);
        this._showDialog = true;
        return this.renderer.render()
            .then(()=>{
                this._options = _.cloneDeep(this._optionsDefaults);
                this._showDialog = false;
                this.renderer.render();
                return Promise.resolve();
            });
    }
    get showDialog(){
        return this._showDialog;
    }
    set showDialog(bool){
        this._showDialog = bool;
    }
    get options(){
        return this._options;
    }
    set options(newOpts){
        this._options = newOpts;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=MessageDialogComponent;